export const getExpirationDate = (date: Date, daysLimit: number) => {
  return new Date(date.getTime() + daysLimit * 24 * 60 * 60 * 1000);
};
